<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-8">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <h5 class="form-header" v-if="current.codigo">
                  Información de super cliente &nbsp;&nbsp;
                  <i class="fas fa-user-circle fa-2x"></i>
                  <div style="float: right">{{ current.codigo }}</div>
                </h5>

                <h5 class="form-header" v-if="current.codigo == null">
                  Nuevo super cliente
                </h5>
                <div class="form-desc" v-if="current.nit == null">
                  Adición de un super cliente para compra de productos o servicios
                </div>
                <div class="form-desc" v-if="current.nit != null">
                  Visualización de la información del super cliente
                </div>
                <div class="row">
                  <div class="col-sm-5">
                    <TiendaSelectComponent
                      :disabled="current.tienda == null"
                      :current="current"
                    />
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.nombre,
                        }"
                        >Nombre</label
                      >
                      <input
                        v-model="current.nombre"
                        class="form-control"
                        placeholder="Nombre"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.nombre,
                        }"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.nombre"
                        class="form-text text-danger"
                        >{{ current.errors.nombre[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-3 col-md-3">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.telefono,
                        }"
                        >teléfono</label
                      >
                      <input
                        v-model="current.telefono"
                        class="form-control"
                        placeholder="telefono"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.telefono,
                        }"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.telefono"
                        class="form-text text-danger"
                        >{{ current.errors.telefono[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-3 col-md-3">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.dpi,
                        }"
                        >DPI</label
                      >
                      <input
                        v-model="current.dpi"
                        autofocus="autofocus"
                        class="form-control"
                        placeholder="DPI"
                        type="text"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.dpi,
                        }"
                      />
                      <small
                        v-if="current.errors && current.errors.dpi"
                        class="form-text text-danger"
                        >{{ current.errors.dpi[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.direccion,
                        }"
                        >Dirección</label
                      >
                      <textarea
                        v-model="current.direccion"
                        class="form-control"
                        placeholder="Dirección"
                        autofocus="autofocus"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.direccion,
                        }"
                        type="text"
                      ></textarea>
                      <small
                        v-if="current.errors && current.errors.direccion"
                        class="form-text text-danger"
                        >{{ current.errors.direccion[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-3 col-md-3">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.nit,
                        }"
                        >NIT</label
                      >
                      <input
                        v-model="current.nit"
                        autofocus="autofocus"
                        class="form-control"
                        placeholder="NIT"
                        type="text"
                        v-bind:class="{
                          'is-invalid': current.errors && current.errors.nit,
                        }"
                      />
                      <small
                        v-if="current.errors && current.errors.nit"
                        class="form-text text-danger"
                        >{{ current.errors.nit[0] }}</small
                      >
                    </div>
                  </div>
                </div>
                <div class="form-buttons-w">
                  <button class="btn btn-primary" type="submit">
                    Guardar <i class="fas fa-save"></i>
                  </button>
                  <router-link
                    class="btn btn-default"
                    :to="{ name: 'cat-superclientes', params: {} }"
                  >
                    <i class="fa fa-back"></i>
                    Volver al Listado
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-4" style="padding-right: 0px">
          <div
            class="content-panel compact panel panel-hover d-flex flex-column"
            style="height: 420px"
          >
            <div
              style="font-size: 18px; color: green"
              class="text-center font-weight-bold"
            >
              Clientes asignados
            </div>
            <br />
            <div class="row">
              <div class="table" style="overflow-y: scroll; max-height: 270px">
                <table class="col-12 table-hover">
                  <thead>
                    <tr>
                      <th>Nit</th>
                      <th>Nombres</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="det in current.clientes"
                      v-bind:key="det.nit"
                      @click="rowClick(det)"
                    >
                      <td>{{ det.nit }}</td>
                      <td>{{ det.nombre }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="mt-auto">
              <button
                class="btn btn-success btn-block"
                data-toggle="modal"
                data-target="#exampleModal"
              >
                Asignar cliente <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Asignar cliente</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ClientesSelectComponent :current="current" />
          </div>
          <div class="modal-footer">
            <button
              @click="asignarCliente()"
              type="button"
              class="btn btn-outline-success"
            >
              <i class="fas fa-check"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="exampleModal2"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Opciones</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-footer">
            <div class="col-6">
              <button
                @click="desasignarCliente(detalle_)"
                class="btn btn-danger btn-block"
              >
                desasignar cliente <i class="fas fa-times"></i>
              </button>
            </div>
            <router-link
              class="btn btn-info"
              target="_blank"
              :to="{ name: 'cat-clientes-editar', params: { nit: detalle_.nit } }"
            >
              <i class="fa fa-share"></i>
              Ver información de cliente
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Notifications from "@/notifications/notifications";
import ListasPrecioSelectComponent from "@/components/commons/ListasPrecioSelectComponent";
import ClientesSelectComponent from "@/components/commons/ClientesSelectComponent";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    ListasPrecioSelectComponent,
    ClientesSelectComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      detalle_: "",
      current: {
        tienda: "",
        nit: "",
        nombre: "",
        email: "",
        lista_precio: "",
        clientes: [],
        errors: [],
      },
    };
  },

  computed: {},
  mounted() {
    let self = this;
    if (self.$route.params.nit) {
      self.refreshCurrent();
    }
  },

  methods: {
    rowClick(det) {
      $("#exampleModal2").modal("show");
      this.detalle_ = det;
    },
    desasignarCliente() {
      let self = this;
      DynamicService.postAction(
        "cat",
        "super-cliente",
        self.current.codigo,
        "desasignar_cliente",
        {
          cliente_id: this.detalle_.nit,
        }
      ).then((response) => {
        self.refreshCurrent();
        $("#exampleModal2").modal("hide");
        Notifications.alert.success(
          "Desasignar cliente a supercliente",
          "Realizado existosamente"
        );
      });
    },
    asignarCliente() {
      let self = this;
      DynamicService.postAction(
        "cat",
        "super-cliente",
        self.current.codigo,
        "asignar_cliente",
        {
          cliente_id: self.current.cliente_nit.nit,
        }
      )
        .then((response) => {
          self.refreshCurrent();
          $("#exampleModal").modal("hide");
          Notifications.alert.success(
            "Asignar cliente a supercliente",
            "Realizado existosamente"
          );
        })
        .catch((error) => {
          Notifications.alert.error(
            "Asignar cliente a supercliente",
            error.response.data.detail
          );
        });
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById("cat", "super-cliente", self.$route.params.nit).then(
        (response) => {
          self.current = Object.assign(self.current, response.data);
          self.refreshListaPrecio();
          if (response.data.tienda) {
            self.current.tienda = response.data.tienda;
          } else if (
            response.data.codigo &&
            response.data.codigo.substring(0, 2) === "CL" &&
            response.data.codigo.length > 8
          ) {
            self.current.tienda = response.data.codigo.slice(2, -6);
          } else {
            self.current.tienda = null;
          }
          console.log(self.current.tienda);
        }
      );
    },
    refreshListaPrecio() {
      let self = this;
      if (self.current.lista_precio) {
        ListaPreciosService.getById(self.current.lista_precio).then((response) => {
          self.current.lista_precio = response.data;
        });
      }
    },
    guardar(e, confirmarDuplicado) {
      if (e) {
        e.preventDefault();
      }
      let self = this;
      // Evita doble envio mientras se guarda (origen de duplicados consecutivos)
      if (self.guardando_supercliente) {
        return;
      }
      self.guardando_supercliente = true;
      var current = Object.assign({}, self.current);
      if (confirmarDuplicado) {
        current.confirmar_duplicado = true;
      }
      delete current.image;
      if (this.$route.params.nit) {
        current.pk = this.$route.params.nit;
        delete current.nit;
      }
      if (current.lista_precio) {
        current.lista_precio = current.lista_precio.id;
      }
      if (self.$route.params.nit) {
        current.id = self.$route.params.nit;
      }
      console.log(current);
      DynamicService.save("cat", "super-cliente", current)
        .then((res) => {
          self.guardando_supercliente = false;
          self.current.errors = {};
          Notifications.alert.success("Super cliente", "Se ha guardado la Información.");
          if (this.$route.params.nit) {
            self.refreshCurrent();
            return;
          }
          self.$router.push({
            name: "cat-superclientes-editar",
            params: { nit: res.data.codigo },
          });
        })
        .catch((error) => {
          self.guardando_supercliente = false;
          const data = (error.response && error.response.data) || {};
          if ("duplicado_supercliente" in data) {
            self.confirmarDuplicadoSupercliente(data, function () {
              self.guardar(null, true);
            });
            return;
          }
          self.current.errors = Object.assign({}, data);
          if ("nit" in data) {
            Notifications.alert.error("Error", data.nit[0]);
          }
        });
    },
    confirmarDuplicadoSupercliente(data, callback) {
      // El backend avisa que ya existe un supercliente con el mismo nit o
      // nombre (en esta u otra tienda); el usuario decide si lo crea igual.
      swal({
        title: "Supercliente ya existe",
        text: data.detail,
        icon: "warning",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: false,
            visible: true,
          },
          confirm: {
            text: "Si, crearlo de nuevo",
            value: true,
          },
        },
        dangerMode: true,
        closeOnClickOutside: false,
        closeOnEsc: false,
      }).then((acepta) => {
        if (acepta) {
          callback();
        }
      });
    },
    howModal(e) {
      e.preventDefault();
    },
  },
};
</script>
